import {createSelector} from 'reselect';

const selectUam = (state) => state.uam;

const makeSelectUamToken = (codentify) =>
    createSelector(selectUam, (device) => {
        const uamTokenResponses = device?.uamTokenResponses || [];

        return uamTokenResponses.find((x) => x.codentify === codentify)?.uamTokenResponse;
    });

export {makeSelectUamToken};
